import { Injectable } from '@angular/core';
import { SmoochSdkFacade } from '../smooch-sdk-facade/smooch-sdk-facade.service';

@Injectable()
export class ContactUsWidgetService {
  constructor(private smoochSdkFacade: SmoochSdkFacade) {}

  async initAsync(): Promise<any> {
    await this.smoochSdkFacade.initAsync();
  }

  openContactUs(message?: string): void {
    this.smoochSdkFacade.open(message);
  }
}
